import * as React from 'react'

const SvgPaymentOrderIcon = ({ stroke }) => (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.39985C1 4.7197 1 3.87962 1.32698 3.23788C1.6146 2.6734 2.07354 2.21445 2.63803 1.92683C3.27976 1.59985 4.11984 1.59985 5.8 1.59985H12.2C13.8802 1.59985 14.7202 1.59985 15.362 1.92683C15.9265 2.21445 16.3854 2.6734 16.673 3.23788C17 3.87962 17 4.7197 17 6.39985V19.5999L14.25 17.5999L11.75 19.5999L9 17.5999L6.25 19.5999L3.75 17.5999L1 19.5999V6.39985Z"
      stroke={stroke ? stroke : '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgPaymentOrderIcon
